<script>
    import Header from './Header.svelte';
    export let params = {}

    let dash_token = params.t
    let mebot_id = params.id
    let stat_mebot_id = params.m_id

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('artifacts');
</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>
<center>
<br><br>
    <div style="width: 300px; overflow: hidden">
		<span class="text-electric" style="font-size: 40px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">
            <table width=240px border=0>
				<tr align="center">
                    <td>🦤</td><td>🎧</td><td>🥄</td>
                </tr>
				<tr align="center">
                    <td>🛸</td><td>🚀</td><td>💩</td>
                </tr>
				<tr align="center">
                    <td>🥊</td><td>📿</td><td>〇</td>
                </tr>
            </table>
        </span>

    </div>

</center>

<style>

    .text-electric-white {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(253, 253, 253, 0.9),
			0 0 14px rgba(252, 252, 252, 0.6);
		font-family: arial;
		color: hsl(60, 19%, 88%);
	}

    .text-electric {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

</style>